(function () {
  const API_URL =
    "https://bzprotifxkahxaihstjp.supabase.co/functions/v1/public-used-discs";

  const API_PAGE_LIMIT = 250;
  const MAX_CATALOG_ITEMS = 3000;

  const PRICE_GROUPS = [
    {
      value: "yellow",
      label: "Yellow",
      stickerColor: "Gul",
      order: 1,
      aliases: ["gul", "yellow"],
      skuPrefixes: ["USED-GUL"]
    },
    {
      value: "pink",
      label: "Pink",
      stickerColor: "Rosa",
      order: 2,
      aliases: ["rosa", "pink"],
      skuPrefixes: ["USED-ROSA"]
    },
    {
      value: "green",
      label: "Green",
      stickerColor: "Grön",
      order: 3,
      aliases: ["gron", "grön", "green"],
      skuPrefixes: ["USED-GRON", "USED-GRÖN"]
    },
    {
      value: "purple",
      label: "Purple",
      stickerColor: "Lila",
      order: 4,
      aliases: ["lila", "purple"],
      skuPrefixes: ["USED-LILA"]
    },
    {
      value: "red",
      label: "Red",
      stickerColor: "Röd",
      order: 5,
      aliases: ["rod", "röd", "red"],
      skuPrefixes: ["USED-ROD", "USED-RÖD"]
    },
    {
      value: "blue",
      label: "Blue",
      stickerColor: "Blå",
      order: 6,
      aliases: ["bla", "blå", "blue"],
      skuPrefixes: ["USED-BLA", "USED-BLÅ"]
    },
    {
      value: "orange",
      label: "Orange",
      stickerColor: "Orange",
      order: 7,
      aliases: ["orange"],
      skuPrefixes: ["USED-TOUR810", "USED-ORANGE"]
    },
    {
      value: "white",
      label: "White",
      stickerColor: "Vit",
      order: 8,
      aliases: ["vit", "white", "custom"],
      skuPrefixes: ["USED-CUSTOM"]
    }
  ];

  const MULTI_FILTERS = {
    price_groups: {
      label: "Price Group",
      placeholder: "All price groups",
      searchPlaceholder: "Search price groups..."
    },
    brands: {
      label: "Brand",
      placeholder: "All brands",
      searchPlaceholder: "Search brands..."
    },
    plastics: {
      label: "Plastic",
      placeholder: "All plastics",
      searchPlaceholder: "Search plastics..."
    },
    molds: {
      label: "Mold",
      placeholder: "All molds",
      searchPlaceholder: "Search molds..."
    },
    disc_types: {
      label: "Type",
      placeholder: "All types",
      searchPlaceholder: "Search types..."
    }
  };

  const root = document.getElementById("heatland-used-discs-root");
  if (!root) return;

  const state = {
    q: "",
    price_groups: [],
    brands: [],
    plastics: [],
    molds: [],
    disc_types: [],
    inked: "",
    condition_min: "",
    condition_max: "",
    weight_min: "",
    weight_max: "",
    price_min: "",
    price_max: "",
    speed_min: "",
    speed_max: "",
    glide_min: "",
    glide_max: "",
    turn_min: "",
    turn_max: "",
    fade_min: "",
    fade_max: "",
    sort: "newest",
    page: 1,
    limit: 48
  };

  let allItems = [];
  let filteredItems = [];
  let currentItems = [];
  let currentPagination = {};
  let shellRendered = false;
  let eventsBound = false;
  let activeController = null;
  let requestSeq = 0;
  let catalogTruncated = false;
  let lastCatalogFetchAt = null;
  let openMultiFilter = "";

  const multiSearch = {
    price_groups: "",
    brands: "",
    plastics: "",
    molds: "",
    disc_types: ""
  };

  const debouncedSearch = debounce(function (input) {
    updateFilterState(input);
  }, 250);

  async function loadCatalog() {
    const seq = ++requestSeq;

    if (activeController) {
      activeController.abort();
    }

    activeController = new AbortController();

    showLoadingState(false);

    try {
      const catalog = await fetchAllUsedDiscs(activeController.signal);

      if (seq !== requestSeq) return;

      allItems = catalog.items.map(function (item, index) {
        item.__catalog_index = index;
        return item;
      });

      catalogTruncated = catalog.truncated;
      lastCatalogFetchAt = new Date();

      if (!shellRendered) {
        applyCurrentState({ updateFilters: false });
        renderShell();
        shellRendered = true;
      }

      applyCurrentState({ updateFilters: true });

      if (!eventsBound) {
        bindEventsOnce();
        eventsBound = true;
      }
    } catch (error) {
      if (error && error.name === "AbortError") return;

      console.error("Used discs API error:", error);
      showError();
    } finally {
      if (seq === requestSeq) {
        activeController = null;
      }
    }
  }

  async function fetchAllUsedDiscs(signal) {
    let page = 1;
    let hasMore = true;
    let items = [];
    let safety = 0;

    while (hasMore && items.length < MAX_CATALOG_ITEMS && safety < 100) {
      safety += 1;

      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("limit", String(API_PAGE_LIMIT));

      const response = await fetch(API_URL + "?" + params.toString(), {
        method: "GET",
        headers: { Accept: "application/json" },
        signal: signal
      });

      if (!response.ok) throw new Error("Failed to load used discs");

      const data = await response.json();
      const pageItems = data.items || [];

      items = items.concat(pageItems);

      hasMore = Boolean(data.pagination && data.pagination.has_more);
      page += 1;

      if (!pageItems.length) break;
    }

    return {
      items: items.slice(0, MAX_CATALOG_ITEMS),
      truncated: hasMore || items.length >= MAX_CATALOG_ITEMS
    };
  }

  function applyCurrentState(options) {
    options = options || {};

    filteredItems = allItems.filter(function (disc) {
      return matchesAllFilters(disc, null);
    });

    filteredItems = sortItems(filteredItems.slice());

    const visibleCount = state.page * state.limit;

    currentItems = filteredItems.slice(0, visibleCount);

    currentPagination = {
      total: filteredItems.length,
      page: state.page,
      limit: state.limit,
      has_more: filteredItems.length > visibleCount
    };

    if (shellRendered) {
      if (options.updateFilters) updateFiltersPanel();
      renderResults();
    }
  }

  function renderShell() {
    root.innerHTML = `
      <div class="used-discs-shell">
        <div class="used-discs-header">
          <div>
            <p data-used-discs-count>${currentPagination.total || 0} available used discs</p>
          </div>
        </div>

        <button class="used-discs-mobile-filter-toggle" type="button">
          Filter & Sort
        </button>

        <div class="used-discs-mobile-overlay" aria-hidden="true"></div>

        <div class="used-discs-filters-panel">
          <div class="used-discs-mobile-filter-header">
            <strong>Filter & Sort</strong>
            <button class="used-discs-mobile-filter-close" type="button" aria-label="Close filters">×</button>
          </div>

          <div data-used-discs-filters>
            ${renderFilters()}
          </div>

          <div class="used-discs-mobile-filter-footer">
            <button class="used-discs-mobile-apply" type="button">Show results</button>
          </div>
        </div>

        <div data-used-discs-status class="used-discs-status" aria-live="polite"></div>

        <div data-used-discs-results></div>

        <div data-used-discs-pagination></div>

        <div id="used-disc-lightbox" class="used-disc-lightbox" aria-hidden="true">
          <div class="used-disc-lightbox-box">
            <button class="used-disc-lightbox-close" type="button" aria-label="Close image">×</button>
            <img src="" alt="">
          </div>
        </div>
      </div>
    `;
  }

  function updateFiltersPanel() {
    const filters = root.querySelector("[data-used-discs-filters]");
    if (!filters) return;

    const active = document.activeElement;
    const activeFilter = active && active.dataset ? active.dataset.filter : "";
    const activeMultiSearch = active && active.dataset ? active.dataset.multiSearch : "";
    const activeValue = active ? active.value : "";
    const activeSelectionStart =
      active && typeof active.selectionStart === "number"
        ? active.selectionStart
        : null;

    filters.innerHTML = renderFilters();

    if (activeFilter) {
      const nextActive = filters.querySelector('[data-filter="' + cssEscape(activeFilter) + '"]');

      if (nextActive) {
        nextActive.focus();

        if (
          activeFilter === "q" &&
          activeSelectionStart !== null &&
          typeof nextActive.setSelectionRange === "function"
        ) {
          nextActive.value = activeValue;
          nextActive.setSelectionRange(activeSelectionStart, activeSelectionStart);
        }
      }

      return;
    }

    if (activeMultiSearch) {
      const nextSearch = filters.querySelector(
        '[data-multi-search="' + cssEscape(activeMultiSearch) + '"]'
      );

      if (nextSearch) {
        nextSearch.focus();

        if (
          activeSelectionStart !== null &&
          typeof nextSearch.setSelectionRange === "function"
        ) {
          nextSearch.setSelectionRange(activeSelectionStart, activeSelectionStart);
        }
      }
    }
  }

  function renderResults() {
    const count = root.querySelector("[data-used-discs-count]");
    const status = root.querySelector("[data-used-discs-status]");
    const results = root.querySelector("[data-used-discs-results]");
    const pagination = root.querySelector("[data-used-discs-pagination]");

    if (count) {
      count.textContent = (currentPagination.total || 0) + " available used discs";
    }

    if (status) {
      const parts = [];

      if (catalogTruncated) {
        parts.push(
          "Showing search/filter results from the first " +
            MAX_CATALOG_ITEMS +
            " loaded used discs."
        );
      }

      if (lastCatalogFetchAt) {
        parts.push("Updated " + formatTime(lastCatalogFetchAt) + ".");
      }

      status.textContent = parts.join(" ");
    }

    if (results) {
      results.removeAttribute("aria-busy");

      results.innerHTML = currentItems.length
        ? '<div class="used-discs-grid">' + currentItems.map(renderCard).join("") + "</div>"
        : '<div class="used-discs-empty">No used discs match your filters.</div>';
    }

    if (pagination) {
      pagination.innerHTML = currentPagination.has_more
        ? '<button class="used-discs-load-more" type="button">Load more</button>'
        : "";
    }
  }

  function renderFilters() {
    return `
      <div class="used-discs-filters">
        <div class="used-filter used-filter-wide">
          <label>Search</label>
          <input data-filter="q" type="search" value="${escapeHtml(state.q)}" placeholder="Search brand, mold, plastic, stamp or SKU" autocomplete="off">
        </div>

        ${renderMultiSelect("price_groups", getPriceGroupOptions())}
        ${renderMultiSelect("brands", getFacetOptions("brands"))}

        ${renderSelect("inked", "Inked", [
          { value: "true", label: "Yes", count: countForInked(true) },
          { value: "false", label: "No", count: countForInked(false) }
        ], "All")}

        ${renderMultiSelect("plastics", getFacetOptions("plastics"))}
        ${renderMultiSelect("molds", getFacetOptions("molds"))}
        ${renderMultiSelect("disc_types", getFacetOptions("disc_types"))}

        <div class="used-filter">
          <label>Sort</label>
          <select data-filter="sort">
            ${option("newest", "Newest")}
            ${option("price_asc", "Lowest price")}
            ${option("price_desc", "Highest price")}
            ${option("mold_asc", "Mold A-Z")}
            ${option("mold_desc", "Mold Z-A")}
            ${option("price_group_asc", "Price group")}
            ${option("price_group_desc", "Price group reverse")}
            ${option("sticker_asc", "Sticker number")}
          </select>
        </div>

        ${renderRange("condition", "Condition")}
        ${renderRange("weight", "Weight")}
        ${renderRange("price", "Price")}
        ${renderRange("speed", "Speed")}
        ${renderRange("glide", "Glide")}
        ${renderRange("turn", "Turn")}
        ${renderRange("fade", "Fade")}

        <button class="used-discs-reset" type="button">Reset</button>
      </div>
    `;
  }

  function renderMultiSelect(key, options) {
    const config = MULTI_FILTERS[key];
    const selected = state[key] || [];
    const selectedSet = {};
    const visibleOptions = filterMultiOptions(key, options);
    const summary = getMultiSummary(key, options);

    selected.forEach(function (value) {
      selectedSet[String(value)] = true;
    });

    return `
      <div class="used-filter used-filter-multiselect ${openMultiFilter === key ? "is-open" : ""}">
        <label>${escapeHtml(config.label)}</label>

        <button
          class="used-filter-multi-toggle"
          type="button"
          data-multi-toggle="${escapeHtml(key)}"
          aria-expanded="${openMultiFilter === key ? "true" : "false"}"
        >
          <span>${escapeHtml(summary)}</span>
          <em>${selected.length ? selected.length + " selected" : ""}</em>
        </button>

        <div class="used-filter-multi-panel">
          <div class="used-filter-multi-search-wrap">
            <input
              class="used-filter-multi-search"
              data-multi-search="${escapeHtml(key)}"
              type="search"
              value="${escapeHtml(multiSearch[key] || "")}"
              placeholder="${escapeHtml(config.searchPlaceholder)}"
              autocomplete="off"
            >
          </div>

          <div class="used-filter-multi-actions">
            <button type="button" data-multi-clear="${escapeHtml(key)}">Clear</button>
            <span>${selected.length} selected</span>
            <button type="button" data-multi-select-all="${escapeHtml(key)}">Select all</button>
          </div>

          <div class="used-filter-multi-list">
            ${
              visibleOptions.length
                ? visibleOptions
                    .map(function (item) {
                      const checked = Boolean(selectedSet[String(item.value)]);
                      const count =
                        typeof item.count === "number" ? " (" + item.count + ")" : "";
                      const dot =
                        key === "price_groups"
                          ? '<span class="used-filter-multi-dot used-filter-multi-dot-' +
                            escapeHtml(item.value) +
                            '"></span>'
                          : "";

                      return `
                        <label class="used-filter-multi-option">
                          <input
                            type="checkbox"
                            data-multi-option="${escapeHtml(key)}"
                            value="${escapeHtml(item.value)}"
                            ${checked ? "checked" : ""}
                          >
                          ${dot}
                          <span>${escapeHtml(item.label + count)}</span>
                        </label>
                      `;
                    })
                    .join("")
                : '<div class="used-filter-multi-empty">No options</div>'
            }
          </div>
        </div>
      </div>
    `;
  }

  function getMultiSummary(key, options) {
    const config = MULTI_FILTERS[key];
    const selected = state[key] || [];

    if (!selected.length) return config.placeholder;

    const labelsByValue = {};
    options.forEach(function (item) {
      labelsByValue[String(item.value)] = item.label;
    });

    const labels = selected.map(function (value) {
      return labelsByValue[String(value)] || String(value);
    });

    if (labels.length === 1) return labels[0];
    if (labels.length === 2) return labels.join(", ");

    return labels[0] + ", " + labels[1] + " +" + (labels.length - 2);
  }

  function filterMultiOptions(key, options) {
    const search = normalizeSearchText(multiSearch[key] || "");

    if (!search) return options;

    const tokens = search.split(" ").filter(Boolean);

    return options.filter(function (item) {
      const haystack = normalizeSearchText(item.label + " " + item.value);
      return tokens.every(function (token) {
        return haystack.indexOf(token) !== -1;
      });
    });
  }

  function renderSelect(key, label, values, placeholder) {
    return `
      <div class="used-filter">
        <label>${escapeHtml(label)}</label>
        <select data-filter="${key}">
          <option value="">${escapeHtml(placeholder)}</option>
          ${values
            .map(function (item) {
              const value = typeof item === "object" ? item.value : item;
              const text = typeof item === "object" ? item.label : item;
              const count =
                typeof item === "object" && typeof item.count === "number"
                  ? " (" + item.count + ")"
                  : "";

              return (
                '<option value="' +
                escapeHtml(value) +
                '" ' +
                (state[key] === String(value) ? "selected" : "") +
                ">" +
                escapeHtml(text + count) +
                "</option>"
              );
            })
            .join("")}
        </select>
      </div>
    `;
  }

  function renderRange(key, label) {
    return `
      <div class="used-filter used-filter-range">
        <label>${escapeHtml(label)}</label>
        <div>
          <input data-filter="${key}_min" type="number" value="${escapeHtml(state[key + "_min"])}" placeholder="Min">
          <input data-filter="${key}_max" type="number" value="${escapeHtml(state[key + "_max"])}" placeholder="Max">
        </div>
      </div>
    `;
  }

  function option(value, label) {
    return (
      '<option value="' +
      escapeHtml(value) +
      '" ' +
      (state.sort === value ? "selected" : "") +
      ">" +
      escapeHtml(label) +
      "</option>"
    );
  }

  function renderCard(disc) {
    const baseTitle =
      [disc.plastic, disc.mold].filter(Boolean).join(" ").trim() || "Used disc";

    const uniqueText = String(disc.unique_text || "").trim();
    const title = uniqueText ? `${baseTitle} - ${uniqueText}` : baseTitle;

    const subtitle = [disc.brand, disc.weight ? disc.weight + "g" : ""]
      .filter(Boolean)
      .join(" · ");

    const flightNumbers = [disc.speed, disc.glide, disc.turn, disc.fade]
      .filter(function (value) {
        return value !== null && value !== undefined && value !== "";
      })
      .join(" / ");

    const conditionText =
      disc.condition !== null && disc.condition !== undefined
        ? disc.condition + "/10"
        : "-";

    const locationText = getLocationText(disc);

    return `
      <article class="used-disc-card">
        <div class="used-disc-image">
          ${
            disc.image_url
              ? '<button class="used-disc-image-button" type="button" data-image="' +
                escapeHtml(disc.image_url) +
                '" data-title="' +
                escapeHtml(title) +
                '">' +
                '<img src="' +
                escapeHtml(disc.image_url) +
                '" alt="' +
                escapeHtml(title) +
                '" loading="lazy">' +
                "</button>"
              : '<div class="used-disc-placeholder">No image yet</div>'
          }
        </div>

        <div class="used-disc-content">
          <h2>${escapeHtml(title)}</h2>
          ${
            flightNumbers
              ? `<div class="used-disc-flight">${escapeHtml(flightNumbers)}</div>`
              : ""
          }
          ${
            locationText
              ? '<div class="used-disc-location-line">' +
                escapeHtml(locationText) +
                "</div>"
              : ""
          }
          <p class="used-disc-subtitle">${escapeHtml(subtitle)}</p>

          <div class="used-disc-meta">
            <span>${escapeHtml(disc.disc_type || "Used disc")}</span>
            <span>${escapeHtml(conditionText)}</span>
            <span>${disc.inked ? "Inked" : "No ink"}</span>
          </div>

          <div class="used-disc-footer">
            <strong>${formatMoney(disc.price)}</strong>

            <button
              class="used-disc-add"
              type="button"
              data-variant-id="${escapeHtml(disc.shopify_variant_id || "")}"
            >
              Add to cart
            </button>
          </div>
        </div>
      </article>
    `;
  }

  function bindEventsOnce() {
    root.addEventListener("input", function (event) {
      const searchInput = event.target.closest("[data-filter]");
      if (searchInput && searchInput.type === "search") {
        debouncedSearch(searchInput);
        return;
      }

      const multiSearchInput = event.target.closest("[data-multi-search]");
      if (multiSearchInput) {
        const key = multiSearchInput.dataset.multiSearch;
        multiSearch[key] = multiSearchInput.value;
        openMultiFilter = key;
        updateFiltersPanel();
      }
    });

    root.addEventListener("change", function (event) {
      const multiOption = event.target.closest("[data-multi-option]");
      if (multiOption) {
        updateMultiState(multiOption.dataset.multiOption);
        return;
      }

      const input = event.target.closest("[data-filter]");
      if (!input) return;

      if (input.type === "search") return;

      updateFilterState(input);
    });

    root.addEventListener("click", async function (event) {
      const multiToggle = event.target.closest("[data-multi-toggle]");
      if (multiToggle) {
        const key = multiToggle.dataset.multiToggle;
        openMultiFilter = openMultiFilter === key ? "" : key;
        updateFiltersPanel();
        return;
      }

      const multiClear = event.target.closest("[data-multi-clear]");
      if (multiClear) {
        const key = multiClear.dataset.multiClear;
        state[key] = [];
        multiSearch[key] = "";
        openMultiFilter = key;
        state.page = 1;
        applyCurrentState({ updateFilters: true });
        return;
      }

      const multiSelectAll = event.target.closest("[data-multi-select-all]");
      if (multiSelectAll) {
        const key = multiSelectAll.dataset.multiSelectAll;
        const options =
          key === "price_groups" ? getPriceGroupOptions() : getFacetOptions(key);
        state[key] = filterMultiOptions(key, options).map(function (item) {
          return String(item.value);
        });
        openMultiFilter = key;
        state.page = 1;
        applyCurrentState({ updateFilters: true });
        return;
      }

      const resetButton = event.target.closest(".used-discs-reset");
      if (resetButton) {
        resetFilters();
        return;
      }

      const loadMoreButton = event.target.closest(".used-discs-load-more");
      if (loadMoreButton) {
        state.page += 1;
        applyCurrentState({ updateFilters: false });
        return;
      }

      const toggle = event.target.closest(".used-discs-mobile-filter-toggle");
      if (toggle) {
        openDrawer();
        return;
      }

      const close = event.target.closest(".used-discs-mobile-filter-close");
      if (close) {
        closeDrawer();
        return;
      }

      const apply = event.target.closest(".used-discs-mobile-apply");
      if (apply) {
        closeDrawer();
        return;
      }

      const overlay = event.target.closest(".used-discs-mobile-overlay");
      if (overlay && event.target === overlay) {
        closeDrawer();
        return;
      }

      const imageButton = event.target.closest(".used-disc-image-button");
      if (imageButton) {
        openLightbox(imageButton.dataset.image, imageButton.dataset.title);
        return;
      }

      const lightbox = root.querySelector("#used-disc-lightbox");
      if (
        event.target.closest(".used-disc-lightbox-close") ||
        (lightbox && event.target === lightbox)
      ) {
        closeLightbox();
        return;
      }

      const addButton = event.target.closest(".used-disc-add");
      if (addButton) {
        await handleAddToCart(addButton);
        return;
      }

      if (!event.target.closest(".used-filter-multiselect") && openMultiFilter) {
        openMultiFilter = "";
        updateFiltersPanel();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        if (openMultiFilter) {
          openMultiFilter = "";
          updateFiltersPanel();
        }

        closeLightbox();
      }
    });
  }

  function updateFilterState(input) {
    state[input.dataset.filter] = input.value;
    state.page = 1;

    applyCurrentState({
      updateFilters: input.type !== "search"
    });
  }

  function updateMultiState(key) {
    const selected = [];

    root
      .querySelectorAll('[data-multi-option="' + cssEscape(key) + '"]')
      .forEach(function (input) {
        if (input.checked) selected.push(input.value);
      });

    state[key] = selected;
    openMultiFilter = key;
    state.page = 1;

    applyCurrentState({ updateFilters: true });
  }

  function resetFilters() {
    Object.keys(state).forEach(function (key) {
      if (Array.isArray(state[key])) state[key] = [];
      else if (key === "sort") state[key] = "newest";
      else if (key === "page") state[key] = 1;
      else if (key === "limit") state[key] = 48;
      else state[key] = "";
    });

    Object.keys(multiSearch).forEach(function (key) {
      multiSearch[key] = "";
    });

    openMultiFilter = "";

    updateFiltersPanel();
    applyCurrentState({ updateFilters: false });
  }

  function matchesAllFilters(disc, excludeKey) {
    if (excludeKey !== "q" && !matchesSearch(disc)) return false;

    if (excludeKey !== "price_groups" && state.price_groups.length) {
      const group = getPriceGroup(disc);
      if (!group || state.price_groups.indexOf(group.value) === -1) return false;
    }

    if (
      excludeKey !== "brands" &&
      state.brands.length &&
      state.brands.indexOf(String(disc.brand || "")) === -1
    ) {
      return false;
    }

    if (
      excludeKey !== "plastics" &&
      state.plastics.length &&
      state.plastics.indexOf(String(disc.plastic || "")) === -1
    ) {
      return false;
    }

    if (
      excludeKey !== "molds" &&
      state.molds.length &&
      state.molds.indexOf(String(disc.mold || "")) === -1
    ) {
      return false;
    }

    if (
      excludeKey !== "disc_types" &&
      state.disc_types.length &&
      state.disc_types.indexOf(String(disc.disc_type || "")) === -1
    ) {
      return false;
    }

    if (excludeKey !== "inked" && state.inked !== "") {
      const wanted = state.inked === "true";
      if (Boolean(disc.inked) !== wanted) return false;
    }

    return (
      matchesRange(disc.condition, state.condition_min, state.condition_max) &&
      matchesRange(disc.weight, state.weight_min, state.weight_max) &&
      matchesRange(disc.price, state.price_min, state.price_max) &&
      matchesRange(disc.speed, state.speed_min, state.speed_max) &&
      matchesRange(disc.glide, state.glide_min, state.glide_max) &&
      matchesRange(disc.turn, state.turn_min, state.turn_max) &&
      matchesRange(disc.fade, state.fade_min, state.fade_max)
    );
  }

  function matchesRange(value, min, max) {
    if (value === null || value === undefined || value === "") {
      return !min && !max;
    }

    const number = Number(value);

    if (min !== "" && min !== null && min !== undefined && number < Number(min)) {
      return false;
    }

    if (max !== "" && max !== null && max !== undefined && number > Number(max)) {
      return false;
    }

    return true;
  }

  function matchesSearch(disc) {
    const query = String(state.q || "").trim();
    if (!query) return true;

    const tokens = tokenizeSearch(query);
    if (!tokens.length) return true;

    const index = buildDiscSearchIndex(disc);

    return tokens.every(function (token) {
      return tokenMatchesDisc(token, index);
    });
  }

  function sortItems(items) {
    return items.sort(function (a, b) {
      if (state.sort === "price_asc") return numberValue(a.price) - numberValue(b.price);
      if (state.sort === "price_desc") return numberValue(b.price) - numberValue(a.price);

      if (state.sort === "mold_asc") {
        return String(a.mold || "").localeCompare(String(b.mold || ""));
      }

      if (state.sort === "mold_desc") {
        return String(b.mold || "").localeCompare(String(a.mold || ""));
      }

      if (state.sort === "price_group_asc") {
        return comparePriceGroup(a, b);
      }

      if (state.sort === "price_group_desc") {
        return comparePriceGroup(b, a);
      }

      if (state.sort === "sticker_asc") {
        return numberValue(a.sticker_number) - numberValue(b.sticker_number);
      }

      return numberValue(a.__catalog_index) - numberValue(b.__catalog_index);
    });
  }

  function comparePriceGroup(a, b) {
    const groupA = getPriceGroup(a);
    const groupB = getPriceGroup(b);

    const orderA = groupA ? groupA.order : 999;
    const orderB = groupB ? groupB.order : 999;

    if (orderA !== orderB) return orderA - orderB;

    return numberValue(a.sticker_number) - numberValue(b.sticker_number);
  }

  function numberValue(value) {
    if (value === null || value === undefined || value === "") return 0;
    return Number(value) || 0;
  }

  function getFacetOptions(key) {
    const counts = {};
    const labels = {};
    const selected = state[key] || [];
    const field = getFieldForFacet(key);

    allItems.forEach(function (disc) {
      if (!matchesAllFilters(disc, key)) return;

      const value = disc[field];

      if (value === null || value === undefined || value === "") return;

      const stringValue = String(value);

      counts[stringValue] = (counts[stringValue] || 0) + 1;
      labels[stringValue] = stringValue;
    });

    selected.forEach(function (value) {
      counts[value] = counts[value] || 0;
      labels[value] = labels[value] || value;
    });

    return Object.keys(counts)
      .sort(function (a, b) {
        return a.localeCompare(b, undefined, { sensitivity: "base" });
      })
      .map(function (value) {
        return {
          value: value,
          label: labels[value],
          count: counts[value]
        };
      });
  }

  function getFieldForFacet(key) {
    if (key === "brands") return "brand";
    if (key === "plastics") return "plastic";
    if (key === "molds") return "mold";
    if (key === "disc_types") return "disc_type";
    return key;
  }

  function getPriceGroupOptions() {
    const counts = {};

    PRICE_GROUPS.forEach(function (group) {
      counts[group.value] = 0;
    });

    allItems.forEach(function (disc) {
      if (!matchesAllFilters(disc, "price_groups")) return;

      const group = getPriceGroup(disc);
      if (!group) return;

      counts[group.value] = (counts[group.value] || 0) + 1;
    });

    return PRICE_GROUPS.map(function (group) {
      return {
        value: group.value,
        label: group.label,
        stickerColor: group.stickerColor,
        count: counts[group.value] || 0
      };
    }).filter(function (group) {
      return group.count > 0 || state.price_groups.indexOf(group.value) !== -1;
    });
  }

  function countForInked(value) {
    return allItems.filter(function (disc) {
      if (!matchesAllFilters(disc, "inked")) return false;
      return Boolean(disc.inked) === Boolean(value);
    }).length;
  }

  function getPriceGroup(disc) {
    const color = normalizeSearchText(disc.sticker_color || "");
    const sku = String(disc.sku || "").toUpperCase();

    for (let i = 0; i < PRICE_GROUPS.length; i++) {
      const group = PRICE_GROUPS[i];

      if (
        group.aliases.some(function (alias) {
          return normalizeSearchText(alias) === color;
        })
      ) {
        return group;
      }

      if (
        group.skuPrefixes.some(function (prefix) {
          return sku.indexOf(prefix.toUpperCase()) === 0;
        })
      ) {
        return group;
      }
    }

    return null;
  }

  function getLocationText(disc) {
    if (!disc.sticker_color && !disc.sticker_number) return "";
    return (
      String(disc.sticker_color || "") +
      (disc.sticker_number ? " #" + disc.sticker_number : "")
    );
  }

  function buildDiscSearchIndex(disc) {
    const baseTitle =
      [disc.plastic, disc.mold].filter(Boolean).join(" ").trim() || "Used disc";

    const uniqueText = String(disc.unique_text || "").trim();
    const title = uniqueText ? `${baseTitle} - ${uniqueText}` : baseTitle;
    const group = getPriceGroup(disc);

    const flightNumbers = [disc.speed, disc.glide, disc.turn, disc.fade]
      .filter(function (value) {
        return value !== null && value !== undefined && value !== "";
      })
      .join(" ");

    const fields = {
      title: title,
      sku: disc.sku || "",
      variant_number: disc.variant_number || "",
      sticker_color: disc.sticker_color || "",
      sticker_number: disc.sticker_number || "",
      price_group: group ? group.label + " " + group.stickerColor : "",
      brand: disc.brand || "",
      plastic: disc.plastic || "",
      mold: disc.mold || "",
      unique: disc.unique_text || "",
      type: disc.disc_type || "",
      weight: disc.weight ? disc.weight + "g " + disc.weight : "",
      condition:
        disc.condition !== null && disc.condition !== undefined
          ? "condition " + disc.condition + " " + disc.condition + "/10"
          : "",
      inked: disc.inked ? "inked yes" : "no ink uninked",
      flight: flightNumbers ? "flight " + flightNumbers : ""
    };

    const allText = normalizeSearchText(
      Object.keys(fields)
        .map(function (key) {
          return fields[key];
        })
        .join(" ")
    );

    return {
      allText: allText,
      compactAllText: compactSearchText(allText),
      allWords: uniqueArray(allText.split(" ").filter(Boolean))
    };
  }

  function tokenMatchesDisc(token, index) {
    if (!token) return true;

    const compactToken = compactSearchText(token);

    if (index.allText.indexOf(token) !== -1) return true;
    if (index.compactAllText.indexOf(compactToken) !== -1) return true;

    return index.allWords.some(function (word) {
      if (word === token) return true;
      if (word.indexOf(token) === 0) return true;
      if (word.indexOf(token) !== -1) return true;

      if (token.length >= 4 && fuzzyTokenMatch(token, word)) return true;

      return false;
    });
  }

  function tokenizeSearch(query) {
    return normalizeSearchText(query)
      .split(" ")
      .map(function (token) {
        return token.trim();
      })
      .filter(Boolean);
  }

  function normalizeSearchText(value) {
    return String(value === null || value === undefined ? "" : value)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/å/g, "a")
      .replace(/ä/g, "a")
      .replace(/ö/g, "o")
      .replace(/æ/g, "ae")
      .replace(/ø/g, "o")
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function compactSearchText(value) {
    return normalizeSearchText(value).replace(/\s+/g, "");
  }

  function fuzzyTokenMatch(token, word) {
    if (!token || !word) return false;

    const lengthDiff = Math.abs(token.length - word.length);
    if (lengthDiff > 2) return false;

    const maxDistance = token.length >= 7 ? 2 : 1;

    return levenshteinDistance(token, word, maxDistance) <= maxDistance;
  }

  function levenshteinDistance(a, b, maxDistance) {
    if (a === b) return 0;

    const lengthDiff = Math.abs(a.length - b.length);
    if (lengthDiff > maxDistance) return maxDistance + 1;

    const previous = [];
    const current = [];

    for (let j = 0; j <= b.length; j++) {
      previous[j] = j;
    }

    for (let i = 1; i <= a.length; i++) {
      current[0] = i;

      let rowMin = current[0];

      for (let j = 1; j <= b.length; j++) {
        const cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;

        current[j] = Math.min(
          previous[j] + 1,
          current[j - 1] + 1,
          previous[j - 1] + cost
        );

        if (current[j] < rowMin) rowMin = current[j];
      }

      if (rowMin > maxDistance) return maxDistance + 1;

      for (let j = 0; j <= b.length; j++) {
        previous[j] = current[j];
      }
    }

    return previous[b.length];
  }

  function uniqueArray(values) {
    const seen = {};
    const result = [];

    values.forEach(function (value) {
      if (!seen[value]) {
        seen[value] = true;
        result.push(value);
      }
    });

    return result;
  }

  function openDrawer() {
    const panel = root.querySelector(".used-discs-filters-panel");
    const overlay = root.querySelector(".used-discs-mobile-overlay");

    if (!panel || !overlay) return;

    panel.classList.add("is-open");
    overlay.classList.add("is-open");
    document.body.classList.add("used-discs-filter-open");
  }

  function closeDrawer() {
    const panel = root.querySelector(".used-discs-filters-panel");
    const overlay = root.querySelector(".used-discs-mobile-overlay");

    if (!panel || !overlay) return;

    panel.classList.remove("is-open");
    overlay.classList.remove("is-open");
    document.body.classList.remove("used-discs-filter-open");
  }

  function openLightbox(imageUrl, title) {
    const lightbox = root.querySelector("#used-disc-lightbox");
    if (!lightbox || !imageUrl) return;

    const img = lightbox.querySelector("img");
    if (!img) return;

    img.src = imageUrl;
    img.alt = title || "Used disc";

    lightbox.classList.add("is-open");
    lightbox.setAttribute("aria-hidden", "false");
  }

  function closeLightbox() {
    const lightbox = root.querySelector("#used-disc-lightbox");
    if (!lightbox) return;

    const img = lightbox.querySelector("img");

    lightbox.classList.remove("is-open");
    lightbox.setAttribute("aria-hidden", "true");

    if (img) {
      img.src = "";
      img.alt = "";
    }
  }

  async function handleAddToCart(button) {
    const variantId = button.dataset.variantId;

    if (!variantId) {
      alert("Missing Shopify variant ID.");
      return;
    }

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = "Adding...";

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Cart add failed:", errorText);
        throw new Error("Could not add to cart");
      }

      await response.json();

      button.textContent = "Added";
      await refreshCartCount();
      showAddedMessage(button);

      setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 2000);
    } catch (error) {
      console.error("Add to cart error:", error);

      button.textContent = "Sold or unavailable";

      setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 2500);
    }
  }

  function showAddedMessage(button) {
    const footer = button.closest(".used-disc-footer");
    if (!footer) return;

    const existingMessage = footer.querySelector(".used-disc-added-message");
    if (existingMessage) existingMessage.remove();

    const message = document.createElement("div");
    message.className = "used-disc-added-message";
    message.innerHTML = 'Added to cart. <a href="/cart">View cart</a>';

    footer.appendChild(message);
  }

  async function refreshCartCount() {
    try {
      const response = await fetch("/cart.js", {
        headers: { Accept: "application/json" }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const count = cart.item_count || 0;

      const selectors = [
        ".cart-count-bubble",
        "[data-cart-count]",
        ".cart-count",
        "#cart-icon-bubble .cart-count-bubble",
        ".site-header__cart-count",
        ".header__cart-count"
      ];

      selectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (element) {
          element.textContent = count;
          element.style.display = count > 0 ? "" : "none";
        });
      });
    } catch (error) {
      console.error("Cart count refresh failed:", error);
    }
  }

  function showLoadingState() {
    if (!shellRendered) {
      root.innerHTML = renderSkeleton();
      return;
    }

    const status = root.querySelector("[data-used-discs-status]");
    const results = root.querySelector("[data-used-discs-results]");

    if (status) {
      status.textContent = "Loading used discs...";
    }

    if (results) {
      results.setAttribute("aria-busy", "true");
    }
  }

  function showError() {
    if (!shellRendered) {
      root.innerHTML =
        '<div class="used-discs-error">Could not load used discs right now. Please try again later.</div>';
      return;
    }

    const status = root.querySelector("[data-used-discs-status]");
    const results = root.querySelector("[data-used-discs-results]");

    if (status) {
      status.textContent = "";
    }

    if (results) {
      results.removeAttribute("aria-busy");
      results.innerHTML =
        '<div class="used-discs-error">Could not load used discs right now. Please try again later.</div>';
    }
  }

  function renderSkeleton() {
    return `
      <div class="used-discs-shell">
        <div class="used-discs-loading">Loading used discs...</div>
      </div>
    `;
  }

  function formatMoney(value) {
    if (value === null || value === undefined || value === "") return "";
    return Number(value).toFixed(0) + " kr";
  }

  function formatTime(date) {
    try {
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
    } catch (error) {
      return "";
    }
  }

  function escapeHtml(value) {
    return String(value === null || value === undefined ? "" : value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }

    return String(value || "").replace(/"/g, '\\"');
  }

  function debounce(fn, delay) {
    let timer;

    return function () {
      const context = this;
      const args = arguments;

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }

  loadCatalog();
})();